import React, { useState, useEffect } from "react";
import FormControl from '@mui/material/FormControl';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import TextField from "@mui/material/TextField";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ChangeRequestModule } from "../../constants/Module";
import { Action } from "../../constants/Common";
import InputAdornment from '@mui/material/InputAdornment';
import dayjs from "dayjs";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import IndividualMilestone from "./individualMilestone";
import { getAllMilestoneList } from "../../api/casp/milestone";
import { MilestoneStatus } from "../../constants/Status";
import Autocomplete from '@mui/material/Autocomplete';
import { MilestoneBudgetType } from "../../constants/MilestoneBudget";
import SweetAlert from "react-bootstrap-sweetalert";
import _ from "lodash"
import { withTranslation } from "react-i18next";


const EditMilestoneModule = (props) => {
    const existingMilestoneObject = {
        name: "",
        description: "",
        cost: "",
        weight: "",
        // aim: "",
        output: "",
        deliverableId: "",
        deliverableObject: undefined,
        estimatedStartDate: '',
        estimatedEndDate: '',
        items: [],
    }
    const [currentMilestone, setCurrentMilestone] = useState()
    const [refreshMilestones, setRefreshMilestones] = useState(+new Date())
    const [isLoading, setIsLoading] = useState(false)
    const [updatedDeliverable, setUpdatedDeliverable] = useState()
    const [disabled, setDisabled] = useState(false);
    const [openAlert, setOpenAlert] = useState(false)
    const [index, setIndex] = useState()
    const [trigger, setTrigger] = useState(new Date())
    const [milestoneBudget, setMilestoneBudget] = useState()
    const [itemBudgetCost, setItemBudgetCost] = useState(0)
    const [isDisable, setIsDisable] = useState(true)

    useEffect(() => {
        setUpdatedDeliverable(props.updatedDeliverable.find((item) => item.id === currentMilestone?.deliverable?.id))
    }, [currentMilestone])

    const milestoneUpdateValidation = Yup.object().shape({
        name: Yup.string()
            .strict(true)
            .trim(props.t('Must not include leading and trailing spaces'))
            .max(250, "Too Long!")
            .matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/, props.t("Name should be in proper type"))
            .required(props.t("Please enter name")),
        description: Yup.string()
            .strict(true)
            .trim(props.t('Must not include leading and trailing spaces'))
            .max(2000, props.t("Too Long!"))
            .required(props.t("Please Enter description")),
        // aim: Yup.string()
        //     .strict(true)
        //     .trim('Must not include leading and trailing spaces')
        //     .max(250, "Too Long!")
        //     .required("Please Enter aim"),
        output: Yup.string()
            .strict(true)
            .trim(props.t('Must not include leading and trailing spaces'))
            .max(2000, props.t("Too Long!"))
            .required(props.t("Please Enter output")),
        deliverableId: Yup.number().integer().required(props.t("Please select a deliverable")),
        deliverableObject: Yup.object().required(props.t("Please select a deliverable")),
        cost: Yup.number()
            .moreThan(0, props.t("Cost cannot be 0 or negative"))
            .required(props.t("Please Enter cost"))
            .test(props.t('two decimal places'), props.t('Numbers can only have two decimal places'), (value) => {
                return value === null || (value && /^\d+(\.\d{0,2})?$/.test(String(value)));
            }),
        weight: Yup.number()
            .min(0, props.t("Too short"))
            .integer()
            .required(props.t("Please Enter weight"))
            .max(100, props.t('Weight cannot exceed more than 100')),
        estimatedStartDate: Yup.date()
            .typeError(props.t("Given date is invalid type"))
            .required(props.t("Please Enter start date"))
            .when(['deliverableId', 'estimatedStartDate'], {
                is: (deliverableId, estimatedStartDate) => deliverableId && estimatedStartDate,
                then: (schema) => schema.min(updatedDeliverable?.startDate?.new ?? dayjs(currentMilestone?.deliverable?.startDate), `${props.t('Start date cannot be less than deliverable start date')} ${dayjs(updatedDeliverable?.startDate?.new ?? currentMilestone?.deliverable?.startDate).format('MM/DD/YYYY')}`).max(updatedDeliverable?.endDate?.new ?? currentMilestone?.deliverable?.endDate, `Start date cannot be greater than deliverable end date ${dayjs(updatedDeliverable?.endDate?.new ?? currentMilestone?.deliverable?.endDate).format('MM/DD/YYYY')}`)
            })
            .when('estimatedEndDate', {
                is: (estimatedEndDate) => { return !!estimatedEndDate },
                then: (schema) => schema.max(Yup.ref('estimatedEndDate'), props.t("Start date cannot be after End date"))
            }),
        estimatedEndDate: Yup.date()
            .typeError(props.t("Given date is invalid type"))
            .required(props.t("Please Enter end date"))
            .when(['deliverableId', 'estimatedEndDate'], {
                is: (deliverableId, estimatedEndDate) => deliverableId && estimatedEndDate,
                then: (schema) => schema.max(updatedDeliverable?.endDate?.new ?? dayjs(currentMilestone?.deliverable?.endDate), `${props.t('End date cannot be greater than deliverable end date')} ${dayjs(updatedDeliverable?.endDate?.new ?? currentMilestone?.deliverable?.endDate).format('MM/DD/YYYY')}`)
            })
            .when('estimatedStartDate', {
                is: (estimatedStartDate) => !!estimatedStartDate,
                then: (schema) => schema.min(Yup.ref('estimatedStartDate'), props.t("End date cannot be before Start date")),
            }),
        type: Yup.string()
            .when('items', {
                is: items => items && items.length > 0,
                then: Yup.string()
                    .strict(true)
                    .trim(props.t('Must not include leading and trailing spaces'))
                    .max(250, props.t("Too Long!"))
                    .optional(),
                otherwise: Yup.string()
                    .strict(true)
                    .trim(props.t('Must not include leading and trailing spaces'))
                    .max(250, props.t("Too Long!"))
                    .required(props.t('Budget type is required'))
            }),
        budgetType: Yup.string()
            .when('type', {
                is: 'Others',
                then: Yup.string()
                    .strict(true)
                    .max(250, props.t("Too Long!"))
                    .trim(props.t('Must not include leading and trailing spaces'))
                    .required(props.t('Please enter custom budget type')),
                otherwise: Yup.string()
            }),
        plannedCost: Yup.number()
            .positive()
            .when('items', {
                is: items => items && items.length > 0,
                then: Yup.number().optional()
                    .typeError(props.t("Planned cost must be a number"))
                    .moreThan(0, props.t("Planned cost cannot be 0 or negative"))
                    .when('deliverableId', {
                        is: (deliverableId) => deliverableId,
                        then: (schema) => schema.max(updatedDeliverable?.cost?.new ?? currentMilestone?.deliverable.cost, `${props.t('Cost of milestone can not exceed the deliverable cost')} ${updatedDeliverable?.cost?.new ?? currentMilestone?.deliverable?.cost}`),
                    }),
                otherwise: Yup.number()
                    .required(props.t('Planned cost is required'))
                    .typeError(props.t("Planned cost must be a number"))
                    .when('deliverableId', {
                        is: (deliverableId) => deliverableId,
                        then: (schema) => schema.max(updatedDeliverable?.cost?.new ?? currentMilestone?.deliverable.cost, `${props.t('Cost of milestone can not exceed the deliverable cost')} ${updatedDeliverable?.cost?.new ?? currentMilestone?.deliverable?.cost}`),
                    })
                    .test(props.t('two decimal places'), props.t('Numbers can only have two decimal places'), (value) => {
                        return value === null || (value && /^\d+(\.\d{0,2})?$/.test(String(value)));
                    })
            }),
        items: Yup.array().of(Yup.object().shape({
            budgetType: Yup.string()
                .strict(true)
                .trim(props.t('Must not include leading and trailing spaces'))
                .max(250, props.t("Too Long!"))
                .required(props.t('Budget type is required')),
            plannedCost: Yup.number()
                .moreThan(0, props.t("Planned cost cannot be 0 or negative"))
                .required(props.t('Planned cost is required'))
                .max(updatedDeliverable?.cost?.new ?? currentMilestone?.deliverable.cost, `${props.t('Cost of milestone can not exceed the deliverable cost')} ${updatedDeliverable?.cost?.new ?? currentMilestone?.deliverable?.cost}`),
        })
        ).required().min(1).max(10)
    }, [
        ['estimatedStartDate', 'estimatedEndDate'],
        ['estimatedStartDate', 'estimatedStartDate'],
        ['estimatedEndDate', 'estimatedEndDate'],
        ['estimatedStartDate', 'deliverableId']
    ]);

    const updateMilestoneFormik = useFormik({
        initialValues: {
            ...existingMilestoneObject,
        },
        validationSchema: milestoneUpdateValidation,
        validateOnMount: true,
        onSubmit: (values) => {
            try {
                setIsLoading(true)
                const tempValues = { ...values }
                const tempId = tempValues.id
                const tempDeliverableId = tempValues.deliverableId
                delete tempValues.id
                delete tempValues.deliverableId
                const constructNewValue = {}
                const existingObject = { ...currentMilestone }
                const existingObjectKeys = Object.keys(existingObject)
                let hasChanges = false
                Object.entries(tempValues).forEach(([dataKey, dataValue]) => {
                    switch (dataKey) {
                        case 'estimatedStartDate':
                        case 'estimatedEndDate': {
                            if (existingObjectKeys.includes(dataKey)) {
                                if (!dayjs(existingObject[dataKey]).isSame(dayjs(dataValue))) {
                                    hasChanges = true
                                    constructNewValue[dataKey] = {
                                        old: dayjs(existingObject[dataKey]).format('YYYY-MM-DD'),
                                        new: dayjs(dataValue).format('YYYY-MM-DD')
                                    }
                                } else {
                                    constructNewValue[dataKey] = dataValue
                                }
                            }
                            break;
                        }
                        case 'cost': {
                            if (existingObjectKeys.includes(dataKey)) {
                                if (!_.isEqual(milestoneBudget, values.items)) {
                                    hasChanges = true
                                    constructNewValue[dataKey] = {
                                        old: existingObject[dataKey],
                                        new: calculateBudgetItemCost()
                                    }
                                    constructNewValue.items = {
                                        old: milestoneBudget,
                                        new: values.items
                                    }
                                } else {
                                    constructNewValue[dataKey] = dataValue
                                }
                            }
                            break;
                        }
                        case 'name':
                        case 'description':
                        case 'output': 
                        case 'weight': {
                            if (existingObjectKeys.includes(dataKey)) {
                                if (existingObject[dataKey] !== dataValue) {
                                    hasChanges = true
                                    constructNewValue[dataKey] = {
                                        old: existingObject[dataKey],
                                        new: dataValue
                                    }
                                } else {
                                    constructNewValue[dataKey] = dataValue
                                }
                            }
                            break;
                        }
                        default: break;
                    }
                })
                console.log('constructNewValue', constructNewValue)

                if (hasChanges) {
                    constructNewValue.id = tempId
                    constructNewValue.deliverableObject = tempValues.deliverableObject
                    constructNewValue.deliverableId = tempDeliverableId
                    constructNewValue.deliverableCost = updatedDeliverable?.cost?.new ?? currentMilestone?.deliverable.cost
                    props.validate({
                        module: ChangeRequestModule.MILESTONE,
                        event: Action.UPDATE,
                    }, constructNewValue, () => {
                        updateMilestoneFormik.resetForm({
                            ...existingMilestoneObject
                        })
                        setCurrentMilestone(null)
                        setRefreshMilestones(+new Date())
                        setIsLoading(false)
                    },
                        () => {
                            setIsLoading(false)
                        })
                } else {
                    setIsLoading(false)
                    toast.error('Please provide a change to the milestone to add it to the change request!');
                }
            } catch (e) {
                // not handle any changes
            }
        },
    });

    const handleKeyDownCost = (event) => {
        if (event.keyCode === 8 || event.keyCode === 13) {
            return;
        }
        const value = event.target.value;
        const regex = /^\d*\.?\d{0,2}$/;

        if (!regex.test(value + event.key)) {
            event.preventDefault();
        }
    }

    const handleKeyDownWeight = (event) => {
        if (event.keyCode === 8 || event.keyCode === 13) {
            return;
        }

        const regex = /^[0-9]+$/;

        if (!regex.test(event.key)) {
            event.preventDefault();
        }
    }

    const handleTypeChange = (_, value) => {
        if (value !== 'Others') {
            updateMilestoneFormik.setFieldValue("budgetType", value ? value : "");
        } else {
            updateMilestoneFormik.setFieldValue("budgetType", "");
        }

        updateMilestoneFormik.setFieldValue("type", value ? value : "");
    }

    const calculateBudgetItemCost = () => {
        if (updateMilestoneFormik.values?.items.length === 1) {
            return parseFloat(updateMilestoneFormik.values?.items[0]?.plannedCost)
        } else if (updateMilestoneFormik.values?.items.length > 1) {
            return updateMilestoneFormik.values.items.reduce((prev, current) => {
                return (prev.plannedCost ? parseFloat(prev.plannedCost) : prev) + parseFloat(current.plannedCost)
            })
        }

        return 0
    }

    const handleAddRow = () => {
        if (updateMilestoneFormik.values.items.length >= 10) {
            return toast.error("You cannot add more than 10 item.");
        }

        if (updateMilestoneFormik.values.items.length > 0) {
            let existingType = updateMilestoneFormik.values.items.find((data) => data.budgetType.toLowerCase() === updateMilestoneFormik.values.budgetType.toLowerCase())
            if (existingType) {
                return toast.error("Budget type should be unique");
            }
        }

        updateMilestoneFormik.setValues({
            ...updateMilestoneFormik.values,
            items: [...updateMilestoneFormik.values.items, {
                type: updateMilestoneFormik.values.type !== '' ? updateMilestoneFormik.values.type : '',
                budgetType: updateMilestoneFormik.values.type === "Others" ? updateMilestoneFormik.values.budgetType : updateMilestoneFormik.values.type,
                plannedCost: parseFloat(updateMilestoneFormik.values.plannedCost),
            }]
        });
        updateMilestoneFormik.setFieldValue("type", "")
        updateMilestoneFormik.setFieldValue("budgetType", "")
        updateMilestoneFormik.setFieldValue("plannedCost", "")
        setTrigger(+new Date())
    };

    const handleDeleteRow = (indexToDelete) => {
        setItemBudgetCost(itemBudgetCost - updateMilestoneFormik.values.items[index]?.plannedCost)
        const updatedRows = updateMilestoneFormik.values.items.filter((_, index) => index !== indexToDelete);
        updateMilestoneFormik.setFieldValue("items", updatedRows)
    };

    useEffect(() => {
        if (updateMilestoneFormik.errors.plannedCost || updateMilestoneFormik.errors.budgetType || (updateMilestoneFormik.values.type === 'Others' && !updateMilestoneFormik.values.budgetType)) {
            setIsDisable(true)
        } else if ((!updateMilestoneFormik.errors.plannedCost && updateMilestoneFormik.values.plannedCost) && (!updateMilestoneFormik.errors.budgetType && updateMilestoneFormik.values.budgetType)) {
            setIsDisable(false)
        } else {
            setIsDisable(true)
        }
    }, [updateMilestoneFormik.errors.plannedCost, updateMilestoneFormik.errors.budgetType, updateMilestoneFormik.values.plannedCost, updateMilestoneFormik.values.budgetType, updateMilestoneFormik.values.type])

    return (
        <div className="editDeliverable_height" style={{ height: 'auto', maxHeight: '1200px' }}>
            <div className="dashed_border position-relative mt-3 mb-5" style={{ paddingBottom: '10px' }}>
                <div className="row">
                    <div className="col-md-12">
                        <FormControl className="agenda_filter w-100">
                            <SearchDropDownListPaginationComponent
                                label={props.t("Select Milestone")}
                                key={refreshMilestones}
                                searchEnabled={false}
                                listCall={getAllMilestoneList}
                                onBlur={() => {
                                    if (!updateMilestoneFormik.touched?.id) {
                                        updateMilestoneFormik.setFieldTouched("id", true, false);
                                    }
                                }}
                                emitItem={(newValue) => {
                                    setCurrentMilestone(newValue)
                                    if (newValue) {
                                        // updateMilestoneFormik.setFieldValue("id", newValue ? newValue.id : "", true);
                                        const milestoneToSet = { ...newValue, estimatedStartDate: dayjs(newValue.estimatedStartDate), estimatedEndDate: dayjs(newValue.estimatedEndDate) }
                                        let budget = []
                                        if (newValue.milestoneBudgets.length) {
                                            budget = newValue.milestoneBudgets.map((eachRow) => {
                                                return {
                                                    id: eachRow.id,
                                                    type: eachRow?.type !== '' ? eachRow?.type : '',
                                                    budgetType: eachRow.budgetType,
                                                    plannedCost: eachRow.plannedCost,
                                                }
                                            })
                                        }
                                        setMilestoneBudget(budget)
                                        updateMilestoneFormik.setValues({
                                            ...updateMilestoneFormik.values,
                                            name: milestoneToSet.name,
                                            description: milestoneToSet.description,
                                            cost: milestoneToSet.cost,
                                            weight: milestoneToSet.weight,
                                            // aim: milestoneToSet.aim,
                                            output: milestoneToSet.output,
                                            deliverableId: milestoneToSet.deliverable?.id ?? '',
                                            deliverableObject: milestoneToSet.deliverable,
                                            estimatedStartDate: milestoneToSet.estimatedStartDate,
                                            estimatedEndDate: milestoneToSet.estimatedEndDate,
                                            id: milestoneToSet.id,
                                            type: '',
                                            budgetType: '',
                                            plannedCost: '',
                                            items: budget
                                        }, true)
                                        setTrigger(+new Date())
                                    }
                                }}
                                apiParams={{
                                    projectId: props?.project?.id,
                                    filterFields: ["currentStatus"],
                                    filterInputs: [`${MilestoneStatus.ONGOING},${MilestoneStatus.CONFIRMATION_REJECTED}`],
                                    excludeFilterFields: ["id"],
                                    excludeFilterInputs: [props?.milestoneList?.map((_mL) => _mL.id).join(',')]
                                }}
                            />
                            {currentMilestone && updateMilestoneFormik.touched.id && updateMilestoneFormik.errors.id && (
                                <span className="text-danger">{updateMilestoneFormik.errors.id}</span>
                            )}
                        </FormControl>
                    </div>
                </div>
                {currentMilestone && (
                    <>
                        <div className="row">
                            <div className="col-md-12 mt-2">
                                <TextField
                                    fullWidth
                                    id="outlined-multiline-static"
                                    label={props.t("Name")}
                                    name="name"
                                    disabled={isLoading}
                                    value={updateMilestoneFormik.values.name}
                                    onChange={updateMilestoneFormik.handleChange}
                                    onBlur={updateMilestoneFormik.handleBlur}
                                    required
                                />
                                {updateMilestoneFormik.touched.name &&
                                    updateMilestoneFormik.errors.name && (
                                        <span className="text-danger d-block">
                                            {updateMilestoneFormik.errors.name}
                                        </span>
                                    )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-2">
                                <TextField
                                    fullWidth
                                    id="outlined-multiline-static"
                                    label={props.t("Description")}
                                    name="description"
                                    type="text"
                                    disabled={isLoading}
                                    multiline
                                    value={updateMilestoneFormik.values.description}
                                    onChange={updateMilestoneFormik.handleChange}
                                    onBlur={updateMilestoneFormik.handleBlur}
                                    required
                                />
                                {updateMilestoneFormik.touched.description &&
                                    updateMilestoneFormik.errors.description && (
                                        <span className="text-danger d-block">
                                            {updateMilestoneFormik.errors.description}
                                        </span>
                                    )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-2">
                                <FormControl className="agenda_filter w-100">
                                    <TextField
                                        fullWidth
                                        id="outlined-multiline-static"
                                        label={props.t("Assigned Deliverable")}
                                        name="deliverable"
                                        type="text"
                                        disabled={true}
                                        value={updateMilestoneFormik.values.deliverableObject?.name}
                                        required
                                    />
                                    {updateMilestoneFormik.touched.deliverableId && updateMilestoneFormik.errors.deliverableId && (
                                        <span className="text-danger">{updateMilestoneFormik.errors.deliverableId}</span>
                                    )}
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-2">
                                <TextField
                                    onWheel={(e) => e.target.blur()}
                                    fullWidth
                                    id="outlined-multiline-static"
                                    label={props.t("Weight")}
                                    name="weight"
                                    type="number"
                                    disabled={isLoading}
                                    value={updateMilestoneFormik.values.weight}
                                    onKeyDown={handleKeyDownWeight}
                                    onChange={updateMilestoneFormik.handleChange}
                                    onBlur={updateMilestoneFormik.handleBlur}
                                    required
                                />
                                {updateMilestoneFormik.touched.weight &&
                                    updateMilestoneFormik.errors.weight && (
                                        <span className="text-danger d-block">
                                            {updateMilestoneFormik.errors.weight}
                                        </span>
                                    )}
                            </div>
                            {/* <div className="col-md-6 mt-2">
                                <TextField
                                    fullWidth
                                    id="outlined-multiline-static"
                                    label={props.t("Goal")}
                                    name="aim"
                                    type="text"
                                    disabled={isLoading}
                                    value={updateMilestoneFormik.values.aim}
                                    onChange={updateMilestoneFormik.handleChange}
                                    onBlur={updateMilestoneFormik.handleBlur}
                                    required
                                />
                                {updateMilestoneFormik.touched.aim &&
                                    updateMilestoneFormik.errors.aim && (
                                        <span className="text-danger d-block">
                                            {updateMilestoneFormik.errors.aim}
                                        </span>
                                    )}
                            </div> */}
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-2">
                                <TextField
                                    fullWidth
                                    id="outlined-multiline-static"
                                    label={props.t("Output")}
                                    name="output"
                                    type="text"
                                    multiline
                                    disabled={isLoading}
                                    value={updateMilestoneFormik.values.output}
                                    onChange={updateMilestoneFormik.handleChange}
                                    onBlur={updateMilestoneFormik.handleBlur}
                                    required
                                />
                                {updateMilestoneFormik.touched.output &&
                                    updateMilestoneFormik.errors.output && (
                                        <span className="text-danger d-block">
                                            {updateMilestoneFormik.errors.output}
                                        </span>
                                    )}
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className=" col-md-6 changeRequest_datePicker mt-2 pe-0">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            label={props.t("Start Date") + ' *'}
                                            format="MM/DD/YYYY"
                                            name="estimatedStartDate"
                                            disabled={isLoading}
                                            value={
                                                updateMilestoneFormik?.values?.estimatedStartDate?.toString().trim()
                                                    ? updateMilestoneFormik.values.estimatedStartDate
                                                    : null
                                            }
                                            on
                                            slotProps={{
                                                field: {
                                                    clearable: true, onBlur: (_) => {
                                                        if (!updateMilestoneFormik.touched?.estimatedStartDate) {
                                                            updateMilestoneFormik.setFieldTouched("estimatedStartDate", true, false);
                                                        }
                                                    }
                                                },
                                                onClear: () => {
                                                    updateMilestoneFormik.setFieldValue("estimatedStartDate", '');
                                                },
                                            }}
                                            onChange={(e) => {
                                                updateMilestoneFormik.setFieldValue(
                                                    "estimatedStartDate",
                                                    e ? dayjs(e) : ''
                                                );
                                                if (!updateMilestoneFormik.touched?.estimatedStartDate) {
                                                    updateMilestoneFormik.setFieldTouched("estimatedStartDate", true, false);
                                                }
                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                                {updateMilestoneFormik.touched.estimatedStartDate &&
                                    updateMilestoneFormik.errors.estimatedStartDate && (
                                        <span className="text-danger d-block">
                                            {updateMilestoneFormik.errors.estimatedStartDate}
                                        </span>
                                    )}
                            </div>
                            <div className="col-md-6 changeRequest_datePicker mt-2">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            label={props.t("End Date") + ' *'}
                                            format="MM/DD/YYYY"
                                            name="estimatedEndDate"
                                            disabled={isLoading}
                                            value={
                                                updateMilestoneFormik?.values?.estimatedEndDate?.toString().trim()
                                                    ? updateMilestoneFormik.values.estimatedEndDate
                                                    : null
                                            }
                                            slotProps={{
                                                field: {
                                                    clearable: true, onBlur: (_) => {
                                                        if (!updateMilestoneFormik.touched?.estimatedEndDate) {
                                                            updateMilestoneFormik.setFieldTouched("estimatedEndDate", true, false);
                                                        }
                                                    }
                                                },
                                                onClear: () => {
                                                    updateMilestoneFormik.setFieldValue("estimatedEndDate", '');
                                                },
                                            }}
                                            onChange={(e) => {
                                                updateMilestoneFormik.setFieldValue(
                                                    "estimatedEndDate",
                                                    e ? dayjs(e) : ''
                                                );
                                                if (!updateMilestoneFormik.touched?.estimatedEndDate) {
                                                    updateMilestoneFormik.setFieldTouched("estimatedEndDate", true, false);
                                                }
                                            }}
                                            required
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                                {updateMilestoneFormik.touched.estimatedEndDate &&
                                    updateMilestoneFormik.errors.estimatedEndDate && (
                                        <span className="text-danger d-block">
                                            {updateMilestoneFormik.errors.estimatedEndDate}
                                        </span>
                                    )}
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12">
                                <p className="title">{props.t('Cost')}: &nbsp; SAR {calculateBudgetItemCost().toFixed(2)}</p>
                            </div>
                        </div>
                        {updateMilestoneFormik.values?.deliverableId &&
                            <>
                                <div className="both_textfields mb-2 flex-two-col d-flex justify-content-between align-items-start">
                                   
                                    <div className="budgetTextfield mt-2 mx-2 plCurrency currency_small_font">
                                        {/* <TextField
                                            onWheel={(e) => e.target.blur()}
                                            label={props.t("Planned Cost")}
                                            type="number"
                                            className="width-unset"
                                            variant="outlined"
                                            size="small"
                                            name="plannedCost"
                                            onKeyDown={handleKeyDownCost}
                                            fullWidth
                                            required
                                            value={updateMilestoneFormik.values.plannedCost}
                                            onChange={(e) => {
                                                updateMilestoneFormik.setFieldValue(
                                                    'plannedCost', e.target.value
                                                );
                                                const totalPlanCost = calculateBudgetItemCost()
                                            }}
                                            onBlur={updateMilestoneFormik.handleBlur}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">SAR</InputAdornment>,
                                            }}
                                        /> */}
                                        <TextField
                                            minimumValue="0"
                                            id="milestone-cost"
                                            variant="outlined"
                                            // label='Deliverable Cost'
                                            decimalPlaces={2}
                                            value={updateMilestoneFormik.values.plannedCost}
                                            // size="small"
                                            currencySymbol={props.t("SAR")}
                                            fullWidth
                                            size="small"
                                            placeholder={props.t("Planned Cost")}
                                            required

                                            // disabled={milestoneCreationLoading}
                                            onChange={(e, newValue) => {
                                                updateMilestoneFormik.setFieldValue('plannedCost', newValue === 0 ? '' : newValue, true)
                                                const totalPlanCost = calculateBudgetItemCost()
                                            }}
                                            onBlur={() => {
                                                updateMilestoneFormik.setFieldTouched('plannedCost', true, true)
                                            }}
                                        />
                                        {updateMilestoneFormik.touched.plannedCost && updateMilestoneFormik.errors.plannedCost && (
                                            <span className="text-danger text-wrap">
                                                {updateMilestoneFormik.errors.plannedCost}
                                            </span>
                                        )}
                                    </div>
                                    {updateMilestoneFormik.values?.type === 'Others' &&
                                        <div className="budgetTextfield mt-2">
                                            <TextField
                                                label={`${updateMilestoneFormik.values?.type !== 'Others' ? props.t('Budget Type') : props.t('Custom Budget Type')} `}
                                                variant="outlined"
                                                size="small"
                                                name="budgetType"
                                                fullWidth
                                                value={updateMilestoneFormik.values.budgetType}
                                                onChange={updateMilestoneFormik.handleChange}
                                                onBlur={updateMilestoneFormik.handleBlur}
                                            />
                                            {updateMilestoneFormik.touched.budgetType && updateMilestoneFormik.errors.budgetType && (
                                                <span className="text-danger">
                                                    {updateMilestoneFormik.errors.budgetType}
                                                </span>
                                            )}
                                        </div>
                                    }
                                    <FormControl className="budgetTextfield mt-2 mx-2">
                                        <Autocomplete
                                            key={trigger}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={updateMilestoneFormik.values?.type === '' ? null : updateMilestoneFormik.values?.type}
                                            size="small"
                                            options={MilestoneBudgetType}
                                            onChange={handleTypeChange}
                                            renderInput={(params) => <TextField {...params}
                                                label={props.t("Type") + ' *'}
                                            />}
                                        />
                                        {updateMilestoneFormik.touched.type && updateMilestoneFormik.errors.type && (
                                            <span className="text-danger d-block">{updateMilestoneFormik.errors.type}</span>
                                        )}
                                    </FormControl>
                                    <i
                                        className={`las la-plus-circle d-inline-block fw-semibold mt-3 fs-22 text-primary mx-2 ${isDisable ? "text-secondary" : ""
                                            }`}
                                        style={{ cursor: isDisable ? 'not-allowed' : 'pointer' }}
                                        onClick={(e) => { isDisable ? e.preventDefault() : handleAddRow() }}
                                    ></i>
                                </div>
                                {(!updateMilestoneFormik.errors.plannedCost && !updateMilestoneFormik.errors.type && !updateMilestoneFormik.errors.budgetType && (updateMilestoneFormik.values.plannedCost || updateMilestoneFormik.values.type)) && (
                                    <span className="text-danger d-block">Please click the plus (+) button after entering the type and planned cost</span>
                                )}
                                <div>
                                    {updateMilestoneFormik.values.items?.length > 0 &&
                                        updateMilestoneFormik.values.items.map((_row, index) => (
                                            <div key={index}>
                                                <div className="both_textfields mt-2 flex-two-col d-flex justify-content-between align-items-start">
                                                    <div className="budgetTextfield mt-2 pe-2">
                                                        {/* <TextField
                                                            onWheel={(e) => e.target.blur()}
                                                            label={props.t("Planned Cost")}
                                                            className="width-unset"
                                                            variant="outlined"
                                                            size="small"
                                                            type="number"
                                                            required
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">SAR</InputAdornment>,
                                                            }}
                                                            name={`items[${index}].plannedCost`}
                                                            fullWidth
                                                            value={_row.plannedCost}
                                                            inputProps={{
                                                                readOnly: true
                                                            }}
                                                        /> */}
                                                        <TextField
                                                            minimumValue="0"
                                                            sx={{ marginLeft: 3 }}
                                                            id="milestone-cost"
                                                            variant="outlined"
                                                            // label='Deliverable Cost'
                                                            decimalPlaces={2}
                                                            value={_row.plannedCost}
                                                            name={`items[${index}].plannedCost`}
                                                            currencySymbol={props.t("SAR")}
                                                            fullWidth
                                                            placeholder={props.t("Planned cost of budget")}
                                                            required
                                                            inputProps={{
                                                                readOnly: true
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="budgetTextfield mt-2 pe-2">
                                                        <TextField
                                                            label={`${_row.type !== 'Others' ? props.t('Budget Type') : props.t('Custom Budget Type')} `}
                                                            variant="outlined"
                                                            size="small"
                                                            className="width-unset"
                                                            required
                                                            name={`items[${index}].budgetType`}
                                                            fullWidth
                                                            value={_row.budgetType}
                                                            inputProps={{
                                                                readOnly: true
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="budgetTextfield mt-2 pe-2">
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                key={trigger}
                                                                name={`items[${index}].type`}
                                                                value={_row?.type === '' ? null : _row?.type}
                                                                size="small"
                                                                label={props.t("Type *")}
                                                                inputProps={{
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </div>
                                                    <i
                                                        className="las la-trash-alt fs-22 text-danger mt-3 mx-2"
                                                        onClick={() => {
                                                            setOpenAlert(true);
                                                            setIndex(index)
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    ></i>
                                                    <div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        )}
                                </div>
                            </>
                        }
                        <div className="d-flex justify-content-center align-items-center mt-4">
                            <button className={`add_anotherButton d-flex align-items-center ${isLoading || !updateMilestoneFormik.isValid ? 'bg-secondary' : ''}`} type="button" onClick={updateMilestoneFormik.handleSubmit} disabled={isLoading || !updateMilestoneFormik.isValid}>
                                {isLoading ? (<Spinner className="ml-1 me-2" type="border" color="light" size="sm" />) : (<i className="ri-add-line ml-1" />)}
                                <span className="pe-2 ps-1">{props.t('Add')}</span>
                            </button>
                        </div>
                    </>
                )}
            </div>
            {
                props?.milestoneList && props?.milestoneList?.map((mL, index) => {
                    return (<IndividualMilestone
                        key={index}
                        action={Action.UPDATE}
                        updatedDeliverable={props.updatedDeliverable.find((item) => item.id === mL.deliverableId)}
                        eachMilestone={mL}
                        eachMilestoneIndex={index}
                        removeItemFromPayload={props?.removeItemFromPayload}
                    />)
                })
            }

            {openAlert && (<SweetAlert
                title={props.t("Are you sure you want to delete this milestone budget") + '?'}
                warning
                showCancel
                confirmBtnText={props.t("OK")}
                cancelBtnText={props.t("Cancel")}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                    setOpenAlert(false)
                    handleDeleteRow(index)
                }}
                onCancel={() => {
                    setOpenAlert(false)
                    setIndex()
                }}>
            </SweetAlert>)
            }
        </div>
    )
}

export default withTranslation() (EditMilestoneModule);